import { render } from "./PreOptinDialogV2StyleModal.vue?vue&type=template&id=b2ded398&scoped=true"
import script from "./PreOptinDialogV2StyleModal.vue?vue&type=script&lang=js"
export * from "./PreOptinDialogV2StyleModal.vue?vue&type=script&lang=js"

import "./PreOptinDialogV2StyleModal.vue?vue&type=style&index=0&id=b2ded398&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ded398"]])

export default __exports__